exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app-Components-Layout---1Gpxi{font-family:EB Garamond,serif}.app-Components-Layout---1Gpxi h1,.app-Components-Layout---1Gpxi h2,.app-Components-Layout---1Gpxi h3,.app-Components-Layout---1Gpxi h4,.app-Components-Layout---1Gpxi h5,.app-Components-Layout---1Gpxi h6{font-family:Josefin Slab,serif}", ""]);

// exports
exports.locals = {
	"className": "app-Components-Layout---1Gpxi"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?localIdentName=[path][name]---[hash:base64:5]!./~/less-loader!./app/Components/Layout.less
 ** module id = 142
 ** module chunks = 0
 **/